import querystring from 'querystring'

export const isDebugSet = initialState => (
  (initialState && initialState.settings && initialState.settings.DEBUG) ||
  (window && window.location && window.location.search && window.location.search.substring &&
  querystring.parse(window.location.search.substring(1)).debug)
)



/** WEBPACK FOOTER **
 ** ./src/utils/debug/debug.js
 **/